import type { IconProps } from '@magicschool/spellbook/components/Icon';
import { Icon } from '@magicschool/spellbook/components/Icon';
import { Slot } from '@magicschool/spellbook/components/Slot';
import type { SpinnerProps } from '@magicschool/spellbook/components/Spinner';
import { Spinner } from '@magicschool/spellbook/components/Spinner';
import { getControlIconSize } from '@magicschool/spellbook/lib/controls';

export const FilterChipToggleLeadingIconSlot = Slot<IconProps>({
  displayName: 'FilterChipToggle.LeadingIcon',
  renderDefault: ({ name = 'square-dashed', color = 'inherit', size: providedSize, ...props }) => {
    const size = getControlIconSize(providedSize);
    return <Icon data-spellbook-name="filter-chip-toggle-leading-icon" name={name} color={color} size={size} {...props} />;
  },
});

export const FilterChipToggleTrailingIconSlot = Slot<IconProps>({
  displayName: 'FilterChipToggle.TrailingIcon',
  renderDefault: ({ name = 'square-dashed', color = 'inherit', size: providedSize, ...props }) => {
    const size = getControlIconSize(providedSize);
    return <Icon data-spellbook-name="filter-chip-toggle-trailing-icon" name={name} color={color} size={size} {...props} />;
  },
});

export const FilterChipToggleSpinnerSlot = Slot<SpinnerProps>({
  displayName: 'FilterChipToggle.Spinner',
  isRenderedByDefault: true,
  renderDefault: ({ size: providedSize, ...props }) => {
    const size = getControlIconSize(providedSize);
    return <Spinner data-spellbook-name="filter-chip-toggle-spinner" size={size} {...props} />;
  },
});
